import App from 'app/app.js';

function LtFocusDirective($timeout) {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      $timeout(function () {
        if (scope.$eval(attrs.ltFocus)) {
          element[0].focus();
        }
      });
    }
  };
}

App.directive('ltFocus', ['$timeout', LtFocusDirective]);
